/*
 * PBL: Toggle the required API params [required attr] for the
 * express checkout payment types.
 */
function toggleForExpressCheckout() {
  var $applePayCheckbox = $('#pay_by_link_transaction_type_apple_pay');
  var $googlePayCheckbox = $('#pay_by_link_transaction_type_google_pay');

  if ($applePayCheckbox.prop('checked') || $googlePayCheckbox.prop('checked')) {
    $('.required-api-param').find('label').addClass('required');
    $('.required-api-param').find('input:visible').attr('required', true);
  } else {
    $('.required-api-param').find('label').removeClass('required');
    $('.required-api-param').find('input').prop('required', false);
  }
}

function markAsRequired(fields) {
  $.each(fields, function (key, field) {
    if (field.required) {
      $('input[id$="' + field.label + '"]:visible').closest('.form-group:not(.email-fieldset)').addClass('required-api-param');
    } else {
      $('input[id$="' + field.label + '"]:visible').closest('.form-group').removeClass('required-api-param');
    }
  });
  toggleForExpressCheckout();
}

var PayByLinkRequiredFields = {
  markAsRequired: markAsRequired,
  toggleForExpressCheckout: toggleForExpressCheckout
};
export default PayByLinkRequiredFields;